import initializeWeatherFaqTelemetry from './components/weather-faq-telemetry';
import initializeWeatherSummaryTelemetry from './components/weather-summary-telemetry';

initializeWeatherFaqTelemetry();
initializeWeatherSummaryTelemetry();
import alertNews from './components/alert-news';
import backgroundBanner from './components/background-banner';
import carousel from './components/carousel';
import cityBtnModal from './components/city-btn-modal';
import common from './components/common';
import geolocation from './components/geolocation';
import geolocationInstructionsModal from './components/geolocation-instructions-modal';
import header from './components/header';
import headerInfoBar from './components/header-info-bar';
import locationsModal from './components/locations-modal';
import modal from './components/modal';
import sidebar from './components/sidebar';
import user from './components/user';
import favoriteCitiesHomepage from './components/favorite-cities-homepage';
import './monkey-patch';

const createLazyFeatureLoader = (importer, init) => {
	let loaded = false;
	let promise = null;

	const load = () => {
		if (loaded) return Promise.resolve();
		if (promise) return promise;

		promise = importer()
			.then(module => {
				const feature = module && module.default ? module.default : module;
				init(feature);
				loaded = true;
			})
			.catch(_err => {
				promise = null;
			});

		return promise;
	};

	load.isLoaded = () => loaded;
	return load;
};

const runOnIdle = (callback, timeout = 1000) => {
	if (typeof window.requestIdleCallback === 'function') {
		window.requestIdleCallback(() => callback(), { timeout });
		return;
	}

	window.setTimeout(() => callback(), 1);
};

const initWhenVisible = (selector, loader, options = {}) => {
	const target = document.querySelector(selector);
	if (!target) return;

	if (typeof window.IntersectionObserver !== 'function') {
		loader();
		return;
	}

	const observer = new IntersectionObserver(
		(entries, currentObserver) => {
			const isVisible = entries.some(entry => entry.isIntersecting);
			if (!isVisible) return;

			currentObserver.disconnect();
			loader();
		},
		{ rootMargin: options.rootMargin || '280px' },
	);

	observer.observe(target);
};

const replayClickAfterLazyInit = (selector, loader) => {
	document.addEventListener(
		'click',
		event => {
			const target = event.target;
			if (!target || !target.closest) return;

			const trigger = target.closest(selector);
			if (!trigger) return;
			if (loader.isLoaded()) return;

			event.preventDefault();
			event.stopImmediatePropagation();

			loader().then(() => {
				requestAnimationFrame(() => {
					trigger.dispatchEvent(
						new MouseEvent('click', {
							bubbles: true,
							cancelable: true,
							view: window,
						}),
					);
				});
			});
		},
		true,
	);
};

const loadLegacyChart = createLazyFeatureLoader(
	() =>
		import(
			/* webpackChunkName: "forecast-today-legacy-chart" */ './components/chart'
		),
	chart => {
		chart.controlVariableChart();
		chart.initChart({});
	},
);

const loadHourlyCarousel = createLazyFeatureLoader(
	() =>
		import(
			/* webpackChunkName: "forecast-today-hourly-carousel" */ './components/hourly-carousel'
		),
	hourlyCarousel => hourlyCarousel.init(),
);

const loadHourlyChartView = createLazyFeatureLoader(
	() =>
		import(
			/* webpackChunkName: "forecast-today-hourly-chart" */ './components/hourly-chart-view'
		),
	hourlyChartView => {
		const eagerIds = Array.from(
			document.querySelectorAll('[data-hourly-chart]'),
		)
			.map(element => element.getAttribute('data-hourly-chart'))
			.filter(Boolean);

		hourlyChartView.init({ eagerIds });
	},
);

const loadRainAlertModal = createLazyFeatureLoader(
	() =>
		import(
			/* webpackChunkName: "forecast-today-rain-alert-modal" */ './components/rain-alert-modal'
		),
	rainAlertModal => rainAlertModal.init(),
);

const loadHumidityAlertModal = createLazyFeatureLoader(
	() =>
		import(
			/* webpackChunkName: "forecast-today-humidity-alert-modal" */ './components/humidity-alert-modal'
		),
	humidityAlertModal => humidityAlertModal.init(),
);

const loadWindAlertModal = createLazyFeatureLoader(
	() =>
		import(
			/* webpackChunkName: "forecast-today-wind-alert-modal" */ './components/wind-alert-modal'
		),
	windAlertModal => windAlertModal.init(),
);

const loadTemperatureAlertModal = createLazyFeatureLoader(
	() =>
		import(
			/* webpackChunkName: "forecast-today-temperature-alert-modal" */ './components/temperature-alert-modal'
		),
	temperatureAlertModal => temperatureAlertModal.init(),
);

const loadRainLevelsModal = createLazyFeatureLoader(
	() =>
		import(
			/* webpackChunkName: "forecast-today-rain-levels-modal" */ './components/rain-levels-modal'
		),
	rainLevelsModal => rainLevelsModal.init(),
);

const loadFiftCityLink = createLazyFeatureLoader(
	() =>
		import(
			/* webpackChunkName: "forecast-today-city-link" */ './components/fift-city-link'
		),
	handleCityLinkClick => handleCityLinkClick(),
);

const loadAccordionFaqHome = createLazyFeatureLoader(
	() =>
		import(
			/* webpackChunkName: "forecast-today-faq-home" */ './components/accordion-faq-home'
		),
	accordionFaqHome =>
		accordionFaqHome.handleAnswerOpening({ trackingKey: 'FaqForecast' }),
);

const loadAccordionNearby2026 = createLazyFeatureLoader(
	() =>
		import(
			/* webpackChunkName: "forecast-today-nearby-accordion" */ './components/accordion-nearby-2026'
		),
	accordionNearby2026 => accordionNearby2026.init(),
);

const controlHourlyMenu = () => {
	$(document).on('click', '.hourly-forecast-menu__option', function () {
		const $switch = $(this).closest('.hourly-forecast-menu__switch');
		const view = $(this).data('view');
		const $menuWrapper = $(this).closest('[data-hourly-menu]');
		const id = $menuWrapper.data('hourly-menu');

		$switch.find('.hourly-forecast-menu__option').removeClass('-active');
		$(this).addClass('-active');

		if (!id) return;

		const $viewsWrapper = $(`[data-hourly-views=${id}]`);
		if (!$viewsWrapper.length) return;

		$viewsWrapper.find('[data-hourly-view]').addClass('_none');
		$viewsWrapper.find(`[data-hourly-view=${view}]`).removeClass('_none');

		if (view === 'list') {
			loadHourlyCarousel();
		}

		if (view === 'chart') {
			loadHourlyChartView();
		}
	});
};

const initDeferredFeatures = () => {
	if (document.getElementById('city-op-input')) {
		replayClickAfterLazyInit('#city-op-input', loadFiftCityLink);
	}

	if (document.querySelector('.home-faq')) {
		initWhenVisible('.home-faq', loadAccordionFaqHome, { rootMargin: '420px' });
	}

	if (document.querySelector('#container-accordion-nearby')) {
		initWhenVisible('#container-accordion-nearby', loadAccordionNearby2026, {
			rootMargin: '420px',
		});
	}

	initWhenVisible('[data-hourly-chart]', loadHourlyChartView, {
		rootMargin: '360px',
	});

	if (
		document.querySelector(
			'[id^="wrapper-chart-"], .act-control-variable-chart',
		)
	) {
		initWhenVisible(
			'[id^="wrapper-chart-"], .act-control-variable-chart',
			loadLegacyChart,
			{ rootMargin: '360px' },
		);
		runOnIdle(loadLegacyChart, 1800);
		replayClickAfterLazyInit('.act-control-variable-chart', loadLegacyChart);
	}

	if (document.querySelector('[data-rain-alert-trigger]')) {
		replayClickAfterLazyInit('[data-rain-alert-trigger]', loadRainAlertModal);
	}

	if (document.querySelector('[data-humidity-alert-trigger]')) {
		replayClickAfterLazyInit(
			'[data-humidity-alert-trigger]',
			loadHumidityAlertModal,
		);
	}

	if (document.querySelector('[data-wind-alert-trigger]')) {
		replayClickAfterLazyInit('[data-wind-alert-trigger]', loadWindAlertModal);
	}

	if (document.querySelector('[data-temperature-alert-trigger]')) {
		replayClickAfterLazyInit(
			'[data-temperature-alert-trigger]',
			loadTemperatureAlertModal,
		);
	}

	if (document.querySelector('[data-rain-levels-trigger]')) {
		replayClickAfterLazyInit('[data-rain-levels-trigger]', loadRainLevelsModal);
	}
};

const controlTodayInfeedSpacing = () => {
	const wrappers = document.querySelectorAll('.today-forecast-card__infeed');
	if (!wrappers.length) return;

	wrappers.forEach(wrapper => {
		const infeed = wrapper.querySelector('#infeed-video');
		if (!infeed) return;

		const syncSpacing = () => {
			const hasContent =
				infeed.childElementCount > 0 ||
				(infeed.textContent || '').trim().length > 0;
			wrapper.classList.toggle('-has-content', hasContent);
		};

		syncSpacing();

		if (typeof window.MutationObserver !== 'function') return;

		const observer = new MutationObserver(syncSpacing);
		observer.observe(infeed, {
			childList: true,
			subtree: true,
			characterData: true,
		});
	});
};

const pushDataLayerEvent = (eventName, elementId) => {
	if (!eventName || !elementId) return;
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({ event: eventName, id: elementId });
};

const initTodayAnalyticsTracking = () => {
	document.addEventListener(
		'click',
		event => {
			const rawTarget = event.target;
			if (!rawTarget || !rawTarget.closest) return;

			const target = rawTarget.closest(
				'[data-analytics-event][data-analytics-id]',
			);
			if (!target) return;
			pushDataLayerEvent(
				target.dataset.analyticsEvent,
				target.dataset.analyticsId,
			);
		},
		true,
	);

	document.addEventListener('change', event => {
		const target = event.target;
		if (
			!target.matches(
				'[data-analytics-open-event][data-analytics-close-event][data-analytics-id]',
			)
		)
			return;
		const eventName = target.checked
			? target.dataset.analyticsOpenEvent
			: target.dataset.analyticsCloseEvent;
		pushDataLayerEvent(eventName, target.dataset.analyticsId);
	});
};

alertNews.getNewestAlert();
alertNews.closeAlert();
backgroundBanner.renderBackgroundBanner();
carousel.initCarousel();
common.autocompleteSearchV2();
common.backToTopButton();
common.setAlertStyle();
common.onScroll();
common.controlMobileSearch();
common.closeBanner();
common.controlMobileMenu();
common.initMetrics();
common.activeTab();
common.centerAgg15Nav();
common.activeMobileTab();
common.handleFavoriteButtonClick();
common.applyDataStyleAttributes();
common.applyWindRotationIndicators();
common.viewData();
geolocation.userGeolocation();
modal.controlModal();
user.controlLoggedMenu();
user.renderWeatherNowByFavoritesLocalesBreadcrumb();
user.controlFavoritesLocalesBreadcrumb();
header.controlMenu();
sidebar.init();
locationsModal.init();
geolocationInstructionsModal.init();
cityBtnModal.init();
headerInfoBar.init();
controlHourlyMenu();
initDeferredFeatures();
controlTodayInfeedSpacing();
initTodayAnalyticsTracking();
favoriteCitiesHomepage.init();
